import Card from 'components/Card/Card.jsx';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Form from 'react-jsonschema-form';
import { connect } from 'react-redux';
//Redux
import { bindActionCreators } from 'redux';
import fields from '../../lib/fields';
import widgets from '../../lib/widgets';
import * as VideosActions from './redux/VideosActions';

const schema = {
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'http://example.com/root.json',
  type: 'object',
  required: ['category', 'title', 'url'],
  properties: {
    category: {
      $id: '#/properties/category',
      type: 'integer',
      title: 'Categoría',
      api: process.env.REACT_APP_URL_API + '/api/categories',
      options: {
        value: 'slug',
        label: 'name'
      },
      default: ''
    },
    title: {
      $id: '#/properties/title',
      type: 'string',
      title: 'Título',
      pattern: '^(.*)$'
    },
    url: {
      $id: '#/properties/url',
      type: 'string',
      title: 'URL de YouTube',
      pattern: '^(.*)$'
    }
  }
};

const uiSchema = {
  category: {
    'ui:widget': 'SelectRemoteWidget'
  }
};

const log = type => console.log.bind(console, type);

class VideosForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false
    };

    console.log('Props', props.match.params);
  }

  componentWillMount() {
    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    console.log('Data submitted: ', formData);

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function() {
        _this.props.history.push('/admin/videos');
      });
    } else {
      this.props.create(formData).then(function() {
        _this.props.history.push('/admin/videos');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.remove(this.state.id).then(function() {
        _this.props.history.push('/admin/videos');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onBlur = (id, value) => {
    console.log('Data submitted: ', this.state.formData);
  };

  render() {
    let { history, Videos } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás desaser está opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Registro</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      widgets={widgets}
                      fields={fields}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={Videos.formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() => history.push('/admin/videos')}
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {id !== 'create' ? (
                            <Button
                              bsStyle="danger"
                              onClick={() => this.onDelete(false)}
                            >
                              Borrar
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    Videos: state.Videos
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(VideosActions, dispatch);
};

const VideosConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(VideosForm);

export default VideosConnect;



// WEBPACK FOOTER //
// ./src/views/Videos/VideosForm.jsx